import statesRaw from "../allcountries/states.json";

const INDIA_COUNTRY_ID = "102";

function extractTableData(jsonArray) {
  const table = jsonArray.find((item) => item.type === "table" && item.data);
  return table?.data || [];
}

const indiaStates = extractTableData(statesRaw)
  .filter((state) => state.countryId === INDIA_COUNTRY_ID)
  .map((state) => ({
    id: state.id,
    name: state.name,
    iso2: state.stateCode,
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

const stateIdByIso2 = Object.fromEntries(
  indiaStates.map((state) => [state.iso2, state.id]),
);

let citiesByStateId = null;

async function loadCitiesIndex() {
  if (citiesByStateId) return citiesByStateId;

  const citiesModule = await import("../allcountries/cities.json");
  const citiesRaw = citiesModule.default || citiesModule;
  const allCities = extractTableData(citiesRaw);

  citiesByStateId = {};
  for (const city of allCities) {
    const stateId = city.stateId;
    if (!citiesByStateId[stateId]) {
      citiesByStateId[stateId] = [];
    }
    citiesByStateId[stateId].push({ name: city.name });
  }

  for (const stateId of Object.keys(citiesByStateId)) {
    citiesByStateId[stateId].sort((a, b) => a.name.localeCompare(b.name));
  }

  return citiesByStateId;
}

export function getIndiaStates() {
  return indiaStates;
}

export function resolveStateCode(value, stateList = indiaStates) {
  if (!value) return "";

  const trimmed = String(value).trim();
  const byIso = stateList.find((state) => state.iso2 === trimmed);
  if (byIso) return byIso.iso2;

  const byName = stateList.find(
    (state) => state.name.toLowerCase() === trimmed.toLowerCase(),
  );
  return byName?.iso2 || "";
}

export async function getCitiesByStateCode(stateCode) {
  const resolvedCode = resolveStateCode(stateCode);
  if (!resolvedCode) return [];

  const stateId = stateIdByIso2[resolvedCode];
  if (!stateId) return [];

  const index = await loadCitiesIndex();
  return index[stateId] || [];
}
